var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPuzzleBase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 803 550"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "puzzle_base_svg__gradient",
    x1: 374.62,
    y1: 187.62,
    x2: 329.1,
    y2: 187.62,
    gradientTransform: "matrix(1 0 0 -1 0 550)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767676"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "puzzle_base_svg__gradient_2",
    x1: 259683,
    y1: 179.78,
    x2: 246493,
    y2: 179.78,
    gradientTransform: "matrix(1 0 0 -1 0 550)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b1b1b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "puzzle_base_svg__gradient_3",
    x1: 208326,
    y1: 153.03,
    x2: 216938,
    y2: 153.03,
    gradientTransform: "matrix(1 0 0 -1 0 550)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#acacac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#686868"
  })), /*#__PURE__*/React.createElement("style", null, ".puzzle_base_svg__cls-1{fill:#b6b6b6}.puzzle_base_svg__cls-2{fill:#737373}.puzzle_base_svg__cls-6{fill:#f0f0f0}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "puzzle_base_svg__cls-1",
    d: "M766.05 282.83L622.13 199.7l-82.48 47.63a8.74 8.74 0 01-6.36.77c-2-.57-2.87-1.9-2.18-3.24a18 18 0 002.1-7.79V212.9l-23.51 2.23c-15.31-3.87-34.75-2.17-50 4.74l-21.76 2.07v23c.14 6.2 3.95 12.1 11.6 16.52 10.82 6.24 27.05 8.3 43.41 5.5 2.34-.4 4.63.11 5.62 1.25s.45 2.65-1.34 3.67l-24.19 14 31.26 50.9-7.57 78.09c.35-.2.74-.38 1.09-.59 10.72-6.19 16.62-14.41 16.43-22.36v-7.38a6.63 6.63 0 011.94-1.09 8.1 8.1 0 016.34.22L594.14 425l209-120.74v-23z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "puzzle_base_svg__cls-1",
    d: "M499.68 336.73l-27-50.72-16.78 9.69-42.82 1.78v22.95l75.25 43.47c1.58.91 1.73 2.41.37 3.66a8.23 8.23 0 01-6.15 1.65 82.78 82.78 0 00-36.18 4l-27.47 1.6v25.48c.05 6.29 3.85 12.28 11.6 16.75 16.72 9.65 45.62 8.73 65.47-1.85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "puzzle_base_svg__cls-2",
    d: "M803.13 281.29l-37.07 1.54-2.66-1.54H594.13V425l209-120.74zM533.12 248.05c-1.85-.6-2.68-1.88-2-3.18a18.47 18.47 0 002-6.68v-25.28l-9.84.94V250h9.84z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "puzzle_base_svg__cls-1",
    d: "M549 408.19l-24.34-14.09c-.75 5.29-3.66 10.59-8.45 15.45l-103.12 4.28c-9.79-12.18-4.32-28.3 15.34-39.66 11.67-6.74 26.75-10.79 41.79-11.5v-23l-36.89 1.65-28.21-16.3-32.93 19-43.07 1.98v23c14.8-.44 28.81 2.41 38.74 8.15 16.84 9.73 18.49 25.31 6 38.34L270 419.76a20 20 0 01-4.39-14.14l-26.72 15.43-42.82 1.78v23l181 104.55 209-120.73v-23z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M367.86 377.11a36.66 36.66 0 016.76 5v-39.44l-2.45 1.4L329.1 346v23c14.81-.48 28.83 2.37 38.76 8.11z",
    fill: "url(#puzzle_base_svg__gradient)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M428.44 374.17c11.67-6.74 26.74-10.79 41.78-11.5v-23l-36.89 1.65-2.85-1.65h-28.16v61h6.07c.12-9.18 6.9-18.9 20.05-26.5z",
    fill: "url(#puzzle_base_svg__gradient_2)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "puzzle_base_svg__cls-2",
    d: "M586.12 406.65L549 408.19l-2.66-1.54h-27.58c-.8 1-1.63 2-2.57 2.9l-103.12 4.28a21.55 21.55 0 01-3.9-7.18h-29.23a29.26 29.26 0 01-2.85 4.87v138.82l209-120.73z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M459.36 423.72c13.34.06 27.46-3.15 38.45-9.49 10.49-6.05 16.35-14.06 16.43-21.84v-22.17h-54.88z",
    fill: "url(#puzzle_base_svg__gradient_3)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "puzzle_base_svg__cls-6",
    d: "M594.14 402l209-120.73-181-104.56-82.48 47.65a8.74 8.74 0 01-6.36.77c-2-.57-2.87-1.89-2.17-3.24 4.85-9.45 1.29-18.83-9.53-25.08-17.21-9.94-47.37-8.69-67.25 2.8s-22 28.91-4.83 38.85c10.82 6.25 27.05 8.3 43.42 5.5 2.33-.4 4.62.11 5.62 1.25s.44 2.65-1.34 3.68l-84.09 48.57L488.38 341c1.58.91 1.73 2.41.37 3.66a8.16 8.16 0 01-6.14 1.65c-16.18-1.95-34.26 1.48-47.22 9-19.88 11.48-22 28.91-4.83 38.85s47.37 8.7 67.25-2.79c12.95-7.48 18.9-17.94 15.52-27.29-.48-1.3.7-2.76 2.86-3.54a8.06 8.06 0 016.34.21z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "puzzle_base_svg__cls-6",
    d: "M377.11 527.39l209-120.74-61.47-35.51c-1.23 8.69-8.25 17.4-19.93 24.14-24.29 14-61.17 15.56-82.2 3.41s-18.38-33.46 5.9-47.49c11.67-6.74 26.75-10.79 41.79-11.5l-65.1-37.61-76 43.91c14.81-.43 28.82 2.41 38.75 8.15 21 12.15 18.39 33.45-5.9 47.48s-61.18 15.56-82.2 3.41c-9.93-5.74-14.86-13.83-14.11-22.39l-69.54 40.18z"
  })));
}

export default SvgPuzzleBase;